import { defineStore } from "pinia";
import apiCheckoutProService from "@/services/http/api-drive/magasin/checkoutPro";
import { useMagasinStore } from './magasin';
import { useContextStore } from './context';
import { usePanierStore } from './panier';

export const StatusTypes = {
  CHECKOUT_REQUEST: 'CHECKOUT_REQUEST',
  CHECKOUT_SUCCESS: 'CHECKOUT_SUCCESS',
  CHECKOUT_ERROR: 'CHECKOUT_ERROR'
}

export const ActionTypes = {
  CREATE: "CREATE",
  CHECKOUT_PROCESS_COMMANDE: "CHECKOUT_PROCESS_COMMANDE"
}

export const useCheckoutProStore = defineStore({
  id: 'checkout-pro',
  state: () => {
    return {
      checkout: null,
      meta: null,
      commande: null,
      status: {
        type: null,
        action: null
      },
      error: null,
      step: {
        mode: 'pro',
        value: 1
      },
      facturationForm: {
        pro_ref: "",
        pro_passee_par: "",
        pro_beneficiaire: "",
        pro_adr_beneficiaire: "",
        cg_ok: true
      }
    }
  },
  actions: {
    setCheckout(checkout) {
      this.checkout = checkout;
    },
    setCheckoutMeta(meta) {
      this.meta = meta;
    },
    removeUnauthProducts() {
      if (this.meta && this.meta.warning) {
        this.meta.warning.unauth_products_list = null;
      }
    },
    setError(error) {
      this.error = error;
    },
    setCommande(commande) {
      this.commande = commande;
    },
    setFacturationForm(form) {
      this.facturationForm.pro_ref = form.pro_ref;
      this.facturationForm.pro_passee_par = form.pro_passee_par;
      this.facturationForm.pro_beneficiaire = form.pro_beneficiaire;
      this.facturationForm.pro_adr_beneficiaire = form.pro_adr_beneficiaire;
      this.facturationForm.cg_ok = form.cg_ok;
    },
    resetError() {
      this.error = null;
    },
    checkoutRequest(action) {
      this.status = {
        type: StatusTypes.CHECKOUT_REQUEST,
        action
      };
    },
    checkoutSuccess(action) {
      this.status = {
        type: StatusTypes.CHECKOUT_SUCCESS,
        action
      };
    },
    checkoutError(action) {
      this.status = {
        type: StatusTypes.CHECKOUT_ERROR,
        action
      };
    },
    setStepMode(mode) {
      this.step.mode = mode;
    },
    setStepValue(value) {
      this.step.value = value;
    },
    resetCheckout() {
      this.checkout = null;
      this.meta = null;
      this.error = null;
      this.facturationForm = {
        pro_ref: "",
        pro_passee_par: "",
        pro_beneficiaire: "",
        pro_adr_beneficiaire: "",
        cg_ok: true
      };
      this.status = {
        type: null,
        action: null
      };
    },
    async create() {
      const magasinStore = useMagasinStore();
      const contextStore = useContextStore();
      const panierStore = usePanierStore();

      this.checkoutRequest(ActionTypes.CREATE);
      try {
        const { data, meta } = await this.$apiDrive.use(apiCheckoutProService).create(magasinStore.id, contextStore.uuid, panierStore.dateLastUpdate);
        this.resetError();
        this.setCheckout(data);
        this.setCheckoutMeta(meta);
        this.checkoutSuccess(ActionTypes.CREATE);
      } catch (error) {
        this.setError(this.$apiDrive.getErrorData(error));
        this.checkoutError(ActionTypes.CREATE);
      }
    },
    async processCreateCommande() {
      const magasinStore = useMagasinStore();
      const contextStore = useContextStore();
      this.checkoutRequest(ActionTypes.CHECKOUT_PROCESS_COMMANDE);
      try {
        const res = await this.$apiDrive.use(apiCheckoutProService).processCreateCommande(magasinStore.id, this.id, contextStore.uuid, this.dateLastUpdate, this.facturationForm);
        this.resetError();
        this.setCommande(res);
        this.checkoutSuccess(ActionTypes.CHECKOUT_PROCESS_COMMANDE);
        return Promise.resolve(res);
      } catch (error) {
        const apiError = this.$apiDrive.getErrorData(error);
        this.setError(apiError);
        this.checkoutError(ActionTypes.CHECKOUT_PROCESS_COMMANDE);
        return Promise.reject(apiError);
      }
    }
  },
  getters: {
    id: (state) => {
      return state.checkout ? state.checkout.id : null;
    },
    unauthProducts: (state) => {
      return state.meta && state.meta.warning ? state.meta.warning.unauth_products_list : null;
    },
    infoNonRetrait: (state) => {
      return state.meta ? state.meta.info_non_retrait : null;
    },
    dateLastUpdate: (state) => {
      return state.checkout ? state.checkout.attributes.dateLastUpdate : null;
    },
    errorMessage: (state) => {
      return state.error && state.error.message ? state.error.message : null;
    },
    panier: (state) => {
      return state.checkout ? state.checkout.attributes.panier.data.attributes : null;
    },
    montantTotalTtc: (state) => {
      return state.checkout && state.checkout.attributes.panier ? parseFloat(state.checkout.attributes.panier.data.attributes.montant_total_ttc) : 0;
    },
    nbProduits: (state) => {
      if (!state.checkout) {
        return 0;
      }
      return state.checkout.attributes.panier.data.attributes.lignes_panier.data.reduce((acc, current) => {
        const next = acc += parseInt(current.attributes.quantite);
        return next;
      }, 0);
    }
  }
})